(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	// LocalizationForm is already defined in footer.liquid, so it will work automatically

	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-21e-v3-top-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';
    
    // Store original parent info for each dropdown
    const dropdownInfo = new WeakMap();
    
    // Position dropdown absolutely relative to picker container
    function positionDropdown(list, button) {
      if (!list || !button || list.hasAttribute('hidden')) return;
      
      // Store original parent if not already stored
      if (!dropdownInfo.has(list)) {
        dropdownInfo.set(list, {
          parent: list.parentElement,
          nextSibling: list.nextSibling
        });
      }
      
      // Hide dropdown initially to prevent flicker
      list.style.visibility = 'hidden';
      list.style.opacity = '0';
      
      // Move to body FIRST to escape header stacking context
      // This is critical for z-index to work above header
      if (list.parentElement !== document.body) {
        document.body.appendChild(list);
      }
      
      // Get button position in viewport
      const buttonRect = button.getBoundingClientRect();
      const dropdownWidth = 160; // 160px
      
      // Calculate centered position below the button
      const centerX = buttonRect.left + (buttonRect.width / 2);
      let left = centerX - (dropdownWidth / 2);
      
      // Clamp to viewport edges
      left = Math.max(8, Math.min(window.innerWidth - dropdownWidth - 8, left));
      const top = buttonRect.bottom + 8;
      
      // Get header z-index and set dropdown higher
      const rootStyle = getComputedStyle(document.documentElement);
      const headerZIndex = rootStyle.getPropertyValue('--header-z-index') || '10000000000000000000000';
      const dropdownZIndex = `calc(${headerZIndex.trim()} + 10)`;
      
      // Use absolute positioning relative to document (includes scroll offset)
      // This makes it scroll with page but appear above header
      const absoluteTop = top + window.scrollY;
      
      // Apply absolute positioning - relative to document, not viewport
      list.style.cssText = `
        position: absolute !important;
        top: ${absoluteTop}px !important;
        left: ${left}px !important;
        width: 160px !important;
        max-width: 160px !important;
        min-width: 160px !important;
        max-height: 200px !important;
        z-index: ${dropdownZIndex} !important;
        margin: 0 !important;
        padding: 8px 0 !important;
        transform: none !important;
        display: block !important;
        box-sizing: border-box !important;
        visibility: visible !important;
        opacity: 1 !important;
      `.trim();
      
      // Store initial position for debugging
      list.setAttribute('data-initial-top', absoluteTop.toString());
      list.setAttribute('data-initial-left', left.toString());
      
      console.log('🔵 [Dropdown] Positioned dropdown:', {
        id: list.id,
        parent: list.parentElement?.tagName,
        isInBody: list.parentElement === document.body,
        zIndex: dropdownZIndex,
        headerZIndex: headerZIndex,
        setTop: absoluteTop,
        setLeft: left,
        isInBody: list.parentElement === document.body,
        buttonRect: {
          top: buttonRect.top,
          left: buttonRect.left,
          bottom: buttonRect.bottom
        }
      });
      
      // Verify it's actually fixed after a frame
      requestAnimationFrame(() => {
        const computed = window.getComputedStyle(list);
        const rect = list.getBoundingClientRect();
        
        console.log('🟢 [Dropdown] After positioning:', {
          id: list.id,
          computedPosition: computed.position,
          computedTop: computed.top,
          computedLeft: computed.left,
          boundingRect: {
            top: rect.top,
            left: rect.left,
            bottom: rect.bottom,
            right: rect.right
          },
          scrollY: window.scrollY,
          scrollX: window.scrollX
        });
        
        if (computed.position !== 'fixed') {
          console.error('❌ [Dropdown] NOT FIXED! Parent may have transform. Actual position:', computed.position);
          
          // Check for parent transforms
          let parent = list.parentElement;
          while (parent && parent !== document.body) {
            const parentStyle = window.getComputedStyle(parent);
            if (parentStyle.transform !== 'none' || 
                parentStyle.perspective !== 'none' || 
                parentStyle.willChange !== 'auto') {
              console.error('❌ [Dropdown] Parent with transform found:', {
                element: parent.tagName,
                className: parent.className,
                transform: parentStyle.transform,
                perspective: parentStyle.perspective,
                willChange: parentStyle.willChange
              });
            }
            parent = parent.parentElement;
          }
        } else {
          console.log('✅ [Dropdown] Position is correctly set to FIXED');
        }
      });
    }
    
    // Restore dropdown to original state
    function restoreDropdown(list) {
      if (!dropdownInfo.has(list)) return;
      
      const info = dropdownInfo.get(list);
      // Move back to original parent
      if (info.parent && list.parentElement === document.body) {
        if (info.nextSibling && info.nextSibling.parentElement === info.parent) {
          info.parent.insertBefore(list, info.nextSibling);
        } else {
          info.parent.appendChild(list);
        }
        list.style.cssText = '';
      }
    }
    
    // Close all other dropdowns except the one specified
    function closeOtherDropdowns(exceptListId) {
      console.log('🔴 [CloseOthers] Closing other dropdowns, keeping:', exceptListId);
      
      // Check all forms first (dropdowns in original location)
      document.querySelectorAll('.header-localization-picker localization-form').forEach(form => {
        const panel = form.querySelector('.disclosure__list');
        if (!panel) return;
        
        const isException = panel.id === exceptListId;
        const isHidden = panel.hasAttribute('hidden');
        
        console.log('🔴 [CloseOthers] Checking form panel:', {
          id: panel.id,
          isHidden: isHidden,
          isException: isException,
          shouldClose: !isException && !isHidden
        });
        
        // Close if it's not the exception AND it's not hidden (visible)
        if (!isException && !isHidden) {
          console.log('🔴 [CloseOthers] Closing form panel:', panel.id);
          
          if (form.hidePanel && typeof form.hidePanel === 'function') {
            console.log('🔴 [CloseOthers] Using form.hidePanel() for:', panel.id);
            form.hidePanel();
          } else {
            console.log('🔴 [CloseOthers] Fallback: setting hidden attribute for:', panel.id);
            panel.setAttribute('hidden', '');
          }
        }
      });
      
      // Also check any lists in body (moved dropdowns)
      const bodyLists = Array.from(document.body.children).filter(el => 
        el.id === 'HeaderCountryList' || el.id === 'HeaderLanguageList'
      );
      
      console.log('🔴 [CloseOthers] Found', bodyLists.length, 'panels in body');
      
      bodyLists.forEach(panel => {
        const isException = panel.id === exceptListId;
        const isHidden = panel.hasAttribute('hidden');
        
        console.log('🔴 [CloseOthers] Checking body panel:', {
          id: panel.id,
          isHidden: isHidden,
          isException: isException,
          shouldClose: !isException && !isHidden
        });
        
        if (!isException && !isHidden) {
          console.log('🔴 [CloseOthers] Closing body panel:', panel.id);
          panel.setAttribute('hidden', '');
          restoreDropdown(panel);
        }
      });
    }
    
    // Handle dropdown open/close
    function handleDropdownToggle(list) {
      const button = document.querySelector(`[aria-controls="${list.id}"]`);
      if (!button) {
        console.warn('⚠️ [Toggle] No button found for list:', list.id);
        return;
      }
      
      const isHidden = list.hasAttribute('hidden');
      console.log('🟡 [Toggle] Dropdown toggle:', {
        id: list.id,
        isHidden: isHidden,
        action: isHidden ? 'CLOSING' : 'OPENING'
      });
      
      if (isHidden) {
        console.log('🟡 [Toggle] Closing dropdown:', list.id);
        restoreDropdown(list);
          } else {
            console.log('🟢 [Toggle] Opening dropdown:', list.id);
            
            // Close other dropdowns IMMEDIATELY when this one opens
            closeOtherDropdowns(list.id);
            
            // Position immediately without delay to prevent flicker
            // Use requestAnimationFrame to ensure DOM is ready but do it synchronously
            requestAnimationFrame(() => {
              console.log('🟢 [Toggle] Positioning dropdown:', list.id);
              positionDropdown(list, button);
            });
          }
    }
    
    // Track which dropdowns were opened via click (persistent) vs hover (temporary)
    const clickOpenedDropdowns = new Set();
    const hoverTimeouts = new Map();
    
    // Initialize
    function init() {
      // Add hover handlers to header picker buttons
      document.querySelectorAll('.header-localization-picker__button').forEach(button => {
        const form = button.closest('localization-form');
        if (!form) return;
        
        const listId = button.getAttribute('aria-controls');
        if (!listId) return;
        
        // Track mouse position
        let isMouseOverButton = false;
        let isMouseOverList = false;
        
        // Hover to open - same as click (but only if not click-opened)
        button.addEventListener('mouseenter', () => {
          isMouseOverButton = true;
          
          // Only open on hover if not click-opened
          if (!clickOpenedDropdowns.has(listId)) {
            const list = document.getElementById(listId);
            if (list && list.hasAttribute('hidden')) {
              // Call the same function that click uses
              if (form.openSelector) {
                form.openSelector();
              }
            }
          }
        });
        
        // Hover to close - same as click (but only if not click-opened)
        button.addEventListener('mouseleave', () => {
          isMouseOverButton = false;
          
          // Only close on unhover if not click-opened and not moving to list
          if (!clickOpenedDropdowns.has(listId) && !isMouseOverList) {
            // Use small delay to allow moving to list
            if (hoverTimeouts.has(listId)) {
              clearTimeout(hoverTimeouts.get(listId));
            }
            
            const timeout = setTimeout(() => {
              if (!isMouseOverList && !clickOpenedDropdowns.has(listId)) {
                // Call the same function that click uses to close
                if (form.hidePanel) {
                  form.hidePanel();
                }
              }
              hoverTimeouts.delete(listId);
            }, 100);
            hoverTimeouts.set(listId, timeout);
          }
        });
        
        // Handle hover on list itself
        const setupListHandlers = (list) => {
          if (!list) return;
          
          list.addEventListener('mouseenter', () => {
            isMouseOverList = true;
            // Clear close timeout (only if not click-opened)
            if (!clickOpenedDropdowns.has(listId)) {
              if (hoverTimeouts.has(listId)) {
                clearTimeout(hoverTimeouts.get(listId));
                hoverTimeouts.delete(listId);
              }
            }
          });
          
          list.addEventListener('mouseleave', () => {
            isMouseOverList = false;
            // Close if not moving to button and not click-opened
            if (!isMouseOverButton && !clickOpenedDropdowns.has(listId)) {
              // Call the same function that click uses to close
              if (form.hidePanel) {
                form.hidePanel();
              }
            }
          });
        };
        
        // Set up handlers for initial list
        const list = document.getElementById(listId);
        if (list) {
          setupListHandlers(list);
        }
        
        // Watch for when list is moved to body
        const parentObserver = new MutationObserver(() => {
          const currentList = document.getElementById(listId);
          if (currentList && currentList.parentElement === document.body) {
            setupListHandlers(currentList);
          }
        });
        parentObserver.observe(document.body, { childList: true });
        
        // Click handler - mark as persistent (perma open)
        button.addEventListener('click', () => {
          // Wait for LocalizationForm to toggle, then mark as click-opened
          setTimeout(() => {
            const list = document.getElementById(listId);
            if (!list) return;
            
            if (list.hasAttribute('hidden')) {
              // Was closed - remove from click-opened set (hover can work again)
              clickOpenedDropdowns.delete(listId);
            } else {
              // Was opened - mark as click-opened (persistent, hover won't close it)
              clickOpenedDropdowns.add(listId);
            }
          }, 10);
        });
      });
      
      // Watch for dropdown open/close via hidden attribute
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
            const list = mutation.target;
            // Check if it's one of our header picker dropdowns
            // Either in the picker container OR moved to body
            const isHeaderPickerList = (list.id === 'HeaderCountryList' || list.id === 'HeaderLanguageList') &&
                                      list.classList.contains('disclosure__list');
            const isInPicker = list.closest('.header-localization-picker');
            const isInBody = list.parentElement === document.body;
            
            console.log('👁️ [Observer] Hidden attribute changed:', {
              id: list.id,
              isHeaderPickerList: isHeaderPickerList,
              isInPicker: !!isInPicker,
              isInBody: isInBody,
              isHidden: list.hasAttribute('hidden'),
              oldValue: mutation.oldValue,
              newValue: list.hasAttribute('hidden') ? 'hidden' : 'visible'
            });
            
            // Handle if it's our dropdown (in picker OR moved to body)
            if (isHeaderPickerList && (isInPicker || isInBody)) {
              handleDropdownToggle(list);
            }
          }
        }
      });
      
      // Observe all dropdown lists (both in picker and any that get moved to body)
      const observeList = (list) => {
        if (list && (list.id === 'HeaderCountryList' || list.id === 'HeaderLanguageList')) {
          observer.observe(list, { attributes: true, attributeFilter: ['hidden'] });
          console.log('👁️ [Observer] Now observing:', list.id);
        }
      };
      
      // Observe initial lists
      document.querySelectorAll('.header-localization-picker .disclosure__list').forEach(observeList);
      
      // Also observe any lists in body (in case they're already there)
      Array.from(document.body.children).forEach(el => {
        if (el.id === 'HeaderCountryList' || el.id === 'HeaderLanguageList') {
          observeList(el);
        }
      });
      
      // Watch for new lists being added to body
      const bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && (node.id === 'HeaderCountryList' || node.id === 'HeaderLanguageList')) {
              observeList(node);
            }
          });
        });
      });
      bodyObserver.observe(document.body, { childList: true });
      
      // Track dropdown position during scroll
      let positionTracker = null;
      
      // Close hover-opened dropdowns on scroll (keep click-opened ones)
      window.addEventListener('scroll', () => {
        document.querySelectorAll('.header-localization-picker .disclosure__list:not([hidden])').forEach(list => {
          const listId = list.id;
          // Only close if it wasn't opened via click
          if (!clickOpenedDropdowns.has(listId)) {
            const form = list.closest('localization-form');
            if (form && form.hidePanel) {
              form.hidePanel();
            }
          }
        });
      }, { passive: true, capture: true });
      
      // Handle resize
      window.addEventListener('resize', () => {
        document.querySelectorAll('.header-localization-picker .disclosure__list:not([hidden])').forEach(list => {
          const button = document.querySelector(`[aria-controls="${list.id}"]`);
          if (button && list.parentElement === document.body) {
            positionDropdown(list, button);
          }
        });
      });
      
    }
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    
    // Also try after a delay for dynamically loaded content
    setTimeout(init, 100);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-video-section"] && !Shopify.designMode) return;
  try {
    
window.onload = function() {
  var videoContainers = document.querySelectorAll('.video-container');

  videoContainers.forEach(function(container) {
    var playButton = container.querySelector('.video-play-btn');
    var videoId = container.getAttribute('data-video-id');

    playButton.addEventListener('click', function() {
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
      iframe.style.position = 'absolute';
      iframe.style.top = '0%';
      iframe.style.bottom = '0%';
      iframe.style.left = '0%';
      iframe.style.right = '0%';
      iframe.setAttribute('width', '100%');
      iframe.setAttribute('height', '100%');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', 'true');

      container.innerHTML = '';
      container.appendChild(iframe);
    });
  });
};

  } catch(e) { console.error(e); }
})();
})();
